// extracted by mini-css-extract-plugin
module.exports = {"forgetPassword":"SignIn_forgetPassword__1r63O"};